import PropTypes from 'prop-types';

import Button from './Button';
import ButtonGroup from './ButtonGroup';
import ClipboardButton from './ClipboardButton';
import CloseButton from './CloseButton';
import DropdownButton from './DropdownButton_DEPRECATED';
import GlobalPrimaryContextButton from './GlobalPrimaryContextButton_DEPRECATED';
import GlobalPrimaryDropdownButton from './GlobalPrimaryDropdownButton_DEPRECATED';
import IconDropdownButton from './IconDropdownButton_DEPRECATED';
import LinkButton from './LinkButton';
import MeatballDropdownButton from './MeatballDropdownButton_DEPRECATED';
import RouterLinkButton from './RouterLinkButton';
import ButtonSplit from './Split_DEPRECATED';
import SubmitButton from './SubmitButton';

export {
  Button,
  ButtonGroup,
  ButtonSplit,
  ClipboardButton,
  CloseButton,
  DropdownButton,
  GlobalPrimaryDropdownButton,
  GlobalPrimaryContextButton,
  IconDropdownButton,
  MeatballDropdownButton,
  LinkButton,
  RouterLinkButton,
  SubmitButton,
};

// TODO: Remove this, should be <Button type="danger" />
export const ButtonDanger = ({ children, ...props }) => (
  <Button type="danger" {...props}>
    {children}
  </Button>
);

ButtonDanger.propTypes = {
  children: PropTypes.node.isRequired,
};

// TODO: Remove this, should be <Button type="subtle" />
export const ButtonSubtle = ({ children, ...props }) => (
  <Button type="subtle" {...props}>
    {children}
  </Button>
);

ButtonSubtle.propTypes = {
  children: PropTypes.node.isRequired,
};

// TODO: Remove this, should be <Button type="primary" />
export const ButtonPrimary = ({ children, ...props }) => (
  <Button type="primary" {...props}>
    {children}
  </Button>
);

ButtonPrimary.propTypes = {
  children: PropTypes.node.isRequired,
};

// TODO: Remove this, should be <Button />
export const ButtonSecondary = ({ children, ...props }) => (
  <Button type="secondary" {...props}>
    {children}
  </Button>
);

ButtonSecondary.propTypes = {
  children: PropTypes.node.isRequired,
};

// TODO: Remove this, unclear why there's a separate React component alias
export const ButtonTable = ButtonSubtle;

// TODO: Remove this, should be <Button type="tertiary" />
export const ButtonTertiary = ({ children, ...props }) => (
  <Button type="tertiary" {...props}>
    {children}
  </Button>
);

ButtonTertiary.propTypes = {
  children: PropTypes.node.isRequired,
};

// TODO: Remove this, should be <Button type="warning" />
export const ButtonWarning = ({ children, ...props }) => (
  <Button type="warning" {...props}>
    {children}
  </Button>
);

ButtonWarning.propTypes = {
  children: PropTypes.node.isRequired,
};

// TODO: Remove this, should be <Button type="danger" /> with appropriate actions
export const SubmitButtonDanger = ({ children, ...props }) => (
  <SubmitButton type="danger" {...props}>
    {children}
  </SubmitButton>
);

SubmitButtonDanger.propTypes = {
  children: PropTypes.node.isRequired,
};

// TODO: Remove this, should be <Button type="primary" /> with appropriate actions
export const SubmitButtonPrimary = ({ children, ...props }) => (
  <SubmitButton type="primary" {...props}>
    {children}
  </SubmitButton>
);

SubmitButtonPrimary.propTypes = {
  children: PropTypes.node.isRequired,
};

// TODO: Remove this, should be <Button /> with appropriate actions
export const SubmitButtonSecondary = ({ children, ...props }) => (
  <SubmitButton type="secondary" {...props}>
    {children}
  </SubmitButton>
);

SubmitButtonSecondary.propTypes = {
  children: PropTypes.node.isRequired,
};

// TODO: Remove this, should not be a button at all. This is a text link
export const LinkButtonPrimary = ({ children, ...props }) => (
  <LinkButton type="primary" {...props}>
    {children}
  </LinkButton>
);

LinkButtonPrimary.propTypes = {
  children: PropTypes.node.isRequired,
};

// TODO: Remove this, should not be a button at all. This is a text link
export const LinkButtonSecondary = ({ children, ...props }) => (
  <LinkButton type="secondary" {...props}>
    {children}
  </LinkButton>
);

LinkButtonSecondary.propTypes = {
  children: PropTypes.node.isRequired,
};

// TODO: Remove this, should not be a button at all. This is a text link
export const LinkButtonSubtle = ({ children, ...props }) => (
  <LinkButton type="subtle" {...props}>
    {children}
  </LinkButton>
);

LinkButtonSubtle.propTypes = {
  children: PropTypes.node.isRequired,
};

// TODO: Remove this, should not be a button at all. This is a text link
export const LinkButtonTertiary = ({ children, ...props }) => (
  <LinkButton type="tertiary" {...props}>
    {children}
  </LinkButton>
);

LinkButtonTertiary.propTypes = {
  children: PropTypes.node.isRequired,
};

// TODO: Remove this, should not be a button at all. This is a text link
export const LinkButtonGitHub = ({ children, ...props }) => (
  <LinkButton type="github" {...props}>
    {children}
  </LinkButton>
);

LinkButtonGitHub.propTypes = {
  children: PropTypes.node.isRequired,
};

// TODO: Remove this, should not be a button at all. This is a text link
export const LinkButtonGitLab = ({ children, ...props }) => (
  <LinkButton type="gitlab" {...props}>
    {children}
  </LinkButton>
);

LinkButtonGitLab.propTypes = {
  children: PropTypes.node.isRequired,
};

// TODO: Remove this, should not be a button at all. This is a text link
export const LinkButtonBitbucket = ({ children, ...props }) => (
  <LinkButton type="bitbucket" {...props}>
    {children}
  </LinkButton>
);

LinkButtonBitbucket.propTypes = {
  children: PropTypes.node.isRequired,
};

// TODO: Remove this, should not be a button at all. This is a text link
export const RouterLinkButtonPrimary = ({ children, ...props }) => (
  <RouterLinkButton type="primary" {...props}>
    {children}
  </RouterLinkButton>
);

RouterLinkButtonPrimary.propTypes = {
  children: PropTypes.node.isRequired,
};

// TODO: Remove this, should not be a button at all. This is a text link
export const RouterLinkButtonSecondary = ({ children, ...props }) => (
  <RouterLinkButton type="secondary" {...props}>
    {children}
  </RouterLinkButton>
);

RouterLinkButtonSecondary.propTypes = {
  children: PropTypes.node.isRequired,
};

// TODO: Remove this, should not be a button at all. This is a text link
export const RouterLinkButtonSubtle = ({ children, ...props }) => (
  <RouterLinkButton type="subtle" {...props}>
    {children}
  </RouterLinkButton>
);

RouterLinkButtonSubtle.propTypes = {
  children: PropTypes.node.isRequired,
};

// TODO: Remove this, should not be a button at all. This is a text link
export const RouterLinkButtonTertiary = ({ children, ...props }) => (
  <RouterLinkButton type="tertiary" {...props}>
    {children}
  </RouterLinkButton>
);

RouterLinkButtonTertiary.propTypes = {
  children: PropTypes.node.isRequired,
};
